import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderItem } from '../models/order-item';
import { ActivatedRoute } from '@angular/router';
import { JsonResponse } from '../models/json-response';
import { Invoice } from '../models/invoice';
import { InvoiceService } from '../services/data.invoice';

declare var successMessage;


@Component({
  selector: 'app-validate',
  templateUrl: './validate.component.html'
})
export class ValidateComponent {
  public code: string;
  private h: HttpClient;
  public valid: boolean;
  public result: string;
  public baseUrl: string;

  constructor(private invoiceService: InvoiceService, private route: ActivatedRoute, http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.code = this.route.snapshot.paramMap.get('code');
    this.baseUrl = baseUrl;
    this.h = http;

    if (this.code) {
      http.get<JsonResponse>(baseUrl + 'api/Product/Validate/' + this.code).subscribe(result => {
        this.valid = result.success;
        console.log(result.message);
        this.result = result.message;
        if (this.valid) {
          http.get<Invoice>(baseUrl + 'api/Product/Invoice/' + this.code).subscribe(result => {
            this.invoiceService.changeInvoice(result);
          }, error => console.error(error));
        }
      }, error => console.error(error));
    }
    else {
      this.valid = false;
    }
  }

  validateClick(event, item) {
    var message = "Your validation code is: " + this.code;
    successMessage(message, "Validation Code");

    this.h.get<JsonResponse>(this.baseUrl + 'api/Product/Validate/' + this.code).subscribe(result => {
      this.valid = result.success;
      console.log(result.message);
      this.result = result.message;
      if (this.valid) {
        this.h.get<Invoice>(this.baseUrl + 'api/Product/Invoice/' + this.code).subscribe(result => {
          this.invoiceService.changeInvoice(result);
        }, error => console.error(error));
      }
    }, error => console.error(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/validate/validate.component.ts